export default __webpack_public_path__ + "static/media/yb-white.312c3713.svg";